// Required to test responsive components

import React from "react"
import MediaQuery from "react-responsive"

const MediaQueryWithDefaultValues = props => {
  return (
    <MediaQuery
      {...props}
      values={{ width: window.innerWidth, height: window.innerHeight }}
    />
  )
}

export default MediaQueryWithDefaultValues
